const IST_TIMEZONE = "Asia/Kolkata";

/** Format ISO timestamp for `<input type="datetime-local" />` in IST. */
export function formatIstDatetimeLocal(iso: string | Date | null | undefined): string {
	if (!iso) return "";
	const date = typeof iso === "string" ? new Date(iso) : iso;
	if (Number.isNaN(date.getTime())) return "";
	const parts = new Intl.DateTimeFormat("en-GB", {
		timeZone: IST_TIMEZONE,
		year: "numeric",
		month: "2-digit",
		day: "2-digit",
		hour: "2-digit",
		minute: "2-digit",
		hour12: false,
	}).formatToParts(date);
	const get = (type: string) => parts.find((p) => p.type === type)?.value ?? "";
	return `${get("year")}-${get("month")}-${get("day")}T${get("hour")}:${get("minute")}`;
}

/** Parse datetime-local value (interpreted as IST wall time) to ISO string for API. */
export function parseIstDatetimeLocalToIso(value: string): string | null {
	const trimmed = value.trim();
	if (!trimmed) return null;
	const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(trimmed);
	if (!match) return null;
	const [, y, mo, d, h, mi] = match;
	const istAsUtcMs = Date.UTC(Number(y), Number(mo) - 1, Number(d), Number(h), Number(mi));
	const utcMs = istAsUtcMs - 5.5 * 60 * 60 * 1000;
	const parsed = new Date(utcMs);
	return Number.isNaN(parsed.getTime()) ? null : parsed.toISOString();
}
